<script>
import { Line } from 'vue-chartjs'

// const brandInfo = '#63c2de'
const brandInfo = 'transparent'

export default Line.extend({
  props: {
    'height': String,
    'dataInput': {
      type: Array,
      default: () => [1, 18, 9, 17, 34, 22, 11],
    },
    'labelInput': {
      type: Array,
      default: () => ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    },
  },
  mounted: function() {
    const datasets = [
      {
        label: '',
        backgroundColor: brandInfo,
        borderColor: 'rgba(255,255,255,.55)',
        data: this.dataInput,
      },
    ]
    this.renderChart({
      labels: this.labelInput,
      datasets: datasets,
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent',
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent',
          },

        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, datasets[0].data) - 5,
            max: Math.max.apply(Math, datasets[0].data) + 5,
          },
        }],
      },
      elements: {
        line: {
          tension: 0.00001,
          borderWidth: 1,
        },
        point: {
          radius: 3,
          hitRadius: 10,
          hoverRadius: 4,
        },
      },
    })
  },
})
</script>



// WEBPACK FOOTER //
// src/components/Charts.vue?3f47984a